// TODO: Replace with yup or simple mask
export const validatePercentage = (value: string) => {
  const regex = /^\d{1,2}((,|\.)\d{0,2})?$|^100$/

  return regex.test(value) || value === ''
}

// TODO: Replace with yup or simple mask
export const validateCurrency = (value: string) => {
  const regex = /^\d{1,6}((,|\.)\d{0,2})?$/

  return regex.test(value) || value === ''
}
